import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CourseService } from '../../course/course.service';

/** Guard route from users that already have a license for the requested route */
@Injectable()
export class LicenseGuard  {

  constructor(private _courseService: CourseService) {}
  canActivate(
    next: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      let programAccessTypeId = +next.children[0].params['programAccessTypeId'];
      let course = this._courseService.courses.find(t => t.ProgramAccessTypeId === programAccessTypeId);

      return course.UserHasALicense == false;
  }
}
